<template>

	<div class="site-wrapper">
		<div class="site-content">

			<div class="page">
				<div class="page__header">
					<div class="page__container">
						<h1 class="page__title">
							{{ t('page.sellPoints.title') }}
						</h1>
					</div>
				</div><!-- /.page__header -->
				<div class="page__content">

					<div class="page__container">
						<div class="row sell-point">
							<div class="col-12 col-md-3 mt-4 sell-point__list">
								<div class="row">
									<div class="col-12 sell-point__list__search">
										{{ t('page.sellpoint.search.title') }}
										<div class="input-group mb-3 mt-2">
											<input type="text" class="form-control" v-model="search">
											<div class="input-group-append">
												<button class="btn btn-danger" type="button">{{
													t('page.sellpoint.search.btn') }}
												</button>
											</div>
										</div>
									</div>
								</div>
								<ul class="sell-point__list__ul">
									<li class="sell-point__list__ul__li"
										v-for="(item, index) in pointsList"
                               :key="index+'-sp-ulli-'+item.name"
										:class="{ 'visible': item.visible, 'hover': item.hover }"
										@click="listClick(item)"
									>
										<div class="sell-point__list__title">
											{{ item.name }}
										</div>
										<div class="sell-point__list__info">
											{{ item.info }}
										</div>
										<div class="sell-point__list__address">
											{{ item.address }}
										</div>
										<div class="sell-point__list__time">
											{{ item.workTime }}
										</div>
									</li>
								</ul>
							</div>
							<div class="col-12 col-md-9">
								<div class="sell-point__map">

									<gmap-map
											:center="center"
											:zoom="zoom"
											ref="sellPoint-map"
											style="width: 100%; height: 1000px"
											v-bind:options="mapStyle"

											@zoom_changed="update('zoom', $event)"
											@center_changed="update('reportedCenter', $event)"
											@maptypeid_changed="update('mapType', $event)" @
											bounds_changed="update('bounds', $event)"
									>
										<gmap-marker
												:key="item.id"
												v-for="(item) in pointsList"
												v-if="item.active"
												:position="item.position"
												:clickable="true"
												:draggable="false"
												:icon="getIcon(item)"
												@mouseover="item.hover = true"
												@mouseout="item.hover = false"
												@click="listClick(item)"
										>
											<!--<gmap-info-window :opened="item.open"  @closeclick="item.open=false">
												<div class="betshop__map__infowindow">
													<div class="betshop__map__infowindow__img" v-if="item.teaserimg"  :style="{ backgroundImage: 'url('+item.teaserimg+')' }">
													</div>
													<div class="betshop__map__infowindow__cnt">
														<h3 class="betshop__map__infowindow__title">[[ item.name ]]</h3>
														<p class="betshop__map__infowindow__address">
															[[ item.address ]] [[ item.housenr ]], [[ item.zip ]] [[ item.city ]]
															<span v-if="item.country">, [[ item.country ]]</span>
														</p>
														<button class="btn btn-success" @click="moreInfo(item)">Mehr</button>
													</div>
												</div>
											</gmap-info-window>-->
										</gmap-marker>
									</gmap-map>
								</div>
							</div>
						</div>
					</div>
				</div><!-- /.page__content -->
			</div><!-- /.page -->

		</div>
		<aside-prefooter :prefooter="false"></aside-prefooter>
	</div>

</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';
	import AsidePrefooter from '@/components/layout/AsidePrefooter';
	import {instance} from '@/api';
	import {sellPointsApi} from '@/api';
	import * as VueGoogleMaps from 'vue2-google-maps';
	import _ from 'lodash';

	// eslint-disable-next-line
	window.loaded = function () {

	};

	export default {
		name: 'SellPoints',
		components: {
			AsidePrefooter
		},
		beforeRouteEnter(to, from, next) {
			instance.get(sellPointsApi.get)
				.then((responce) => {
					//Vue Google maps plugin initial settings
					Vue.use(VueGoogleMaps, {
						load: {
							key: app.$store.getters.getMapToken
						},
						loaded: window.loaded
					});

					next(vm => vm.setData(responce.data));

				}).catch((error) => {
					console.warn('No sell points get from db, using hardcoded.');

					next(vm => vm.setData(markers));

			}).then(() => {

			});

		},
		data() {
			return {
				zoom: 10,
				center: {lat: 32.880406, lng: -8.108224},
				points: [],
				mapStyle: {styles: style},
				search: ''
			}
		},

		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				gMapToken: 'getMapToken'
			}),
			pointsList() {
				/*let pList = [];*/

				let list = this.points.slice();

				//If search field not empty, then filter list
				if (this.search.trim().length > 0) {
					//Filter addresses by search phrase
					list = list.filter((el) => this.filterByPhrase(el));

					//Fit items that we found, but only once in 250ms to not overload gMaps
					this.debouncedFitItems();

				}

				return list.sort((a, b) => {
					if (a.visible && !b.visible) {
						return -1
					} else if (!a.visible && b.visible) {
						return 1;
					} else if (a.visible && b.visible) {
						return 0;
					}
				});
			},
			map() {
				return this.$refs['sellPoint-map'].$mapObject
			}
		},
		watch: {},
		created: function () {

			//Init debounce function for fitItems
			this.debouncedFitItems = _.debounce(this.fitItems, 250)
		},
		mounted() {
			//window.spt = this; //Just for testing purposes

			//this.setData(markers); //Just for testing purposes

		},
		methods: {

			listClick(item) {

				this.map.setZoom(11);
				this.center = item.position;
				let self = this;
				setTimeout(function () {
					self.update('click');
				}, 50)
			},

			// eslint-disable-next-line
			update(type, event) {
				this.checkVisibility();
			},
			checkVisibility() {

				let map = this.map; // your map

				for (let marker of this.pointsList) {
					if (map.getBounds().contains(marker.position)) {
						// code for showing your object, associated with markers[i]
						marker.visible = true;
					} else {
						marker.visible = false;
					}
				}
			},
			setData(points) {

				if (points) {
					//Add some additional parameters to point object
					points.forEach((el) => {
						el.active = true;
						el.open = false;
						el.position = {
							lat: el.lat,
							lng: el.lng
						};
						el.visible = true;
						el.hover = false;

					});
					this.points = points;
					let self = this;
					setTimeout(function () {
						self.fitItems(points);
					}, 300);
				}

			},
			fitItems: function (items) {


				if (typeof items === 'undefined') {
					items = this.pointsList;
				}

				if (typeof google !== 'undefined') {
					//If google loaded, then just do stuff
					// eslint-disable-next-line
					let bounds = new google.maps.LatLngBounds();

					let count = 0;
					let lastActive = {};
					items.forEach(function (item) {
						bounds.extend(item.position);
						count++;
						lastActive = item.position;

					});
					if (count === 1) {
						//If just one point visible, then set map center there, and zoom
						this.map.setZoom(11);
						this.map.setCenter(lastActive);
					} else if (count > 1) {
						//Otherwise use map method to fit bounds

						//Hack to prevent disapearing items on map
						this.$refs['sellPoint-map'].fitBounds(bounds);

						let orig = this.map.getZoom();

						this.map.setZoom(orig + 0.0000000001);

						setTimeout(() => {
							this.map.setZoom(orig);
						}, 1)

					}
				} else {
					//If google script still loading, then make an recursion to promise
					window.loaded = function () {
						this.fitItems(items);
					}
				}


			},
			filterByPhrase(item) {
				let sp = this.search.trim().toLowerCase();


				if (sp.length > 0) {

					//Set fields in what we will search
					const fields = ['name', 'address'];

					let state = false;
					for (var i = 0; i < fields.length; i++) {
						if (item[fields[i]].toLowerCase().indexOf(sp) > -1) {
							state = true;
							break;
						}
					}
					return state;

				}

				//Default return
				return true;
			},
			getIcon(item) {
				if (item.hover) {
					return {
						url: require('@/assets/img/marker-g.png')
					};
				} else {
					return {
						url: require('@/assets/img/marker-r.png')
					};
				}
			}


		}
	}


	//TMP stuff for testing

	var markers = [
		{
			id: 1,
			name: "Hippodrome de Casablanca – Anfa ",
			address: "Marocco, Baracuma 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 33.589151,
			lng: -7.658944,
			info: null,
			marker: null
		},
		{
			id: 2,
			name: "Hippodrome d’El Jadida",
			address: "Marocco, Geroyev oborony odessy 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 33.243138,
			lng: -8.464377,
			info: "Address not true"
		},
		{
			id: 3,
			name: "Hippodrome de Settat",
			address: "Marocco, Good street 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 32.993152,
			lng: -7.622749,
			info: "Address not true"
		},
		{
			id: 4,
			name: "Hippodrome de Meknès ",
			address: "Marocco, Good street 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 33.874444,
			lng: -5.541454,
			info: "Address not true"
		},
		{
			id: 5,
			name: "Hippodrome de Khemisset ",
			address: "Marocco, Good street 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 33.825892,
			lng: -6.071237,
			info: "Address not true"
		},
		{
			id: 6,
			name: "Hippodrome de Rabat ",
			address: "Marocco, Good street 25, 95441",
			workTime: "works from 9:00 till 21:00 Mon-Sat",
			lat: 33.977718,
			lng: -6.854538,
			info: null
		}
	];

	var style = [
		{
			"featureType": "administrative",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#444444"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#f2f2f2"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"hue": "#ffd100"
				}, {
					"saturation": "44"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"saturation": "-1"
				}, {
					"hue": "#ff0000"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry",
			"stylers": [
				{
					"saturation": "-16"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"hue": "#ffd100"
				}, {
					"saturation": "44"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-30"
				}, {
					"lightness": "12"
				}, {
					"hue": "#ff8e00"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				}, {
					"saturation": "-26"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#c0b78d"
				}, {
					"visibility": "on"
				}, {
					"saturation": "4"
				}, {
					"lightness": "40"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffe300"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"hue": "#ffe300"
				}, {
					"saturation": "-3"
				}, {
					"lightness": "-10"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#ff0000"
				}, {
					"saturation": "-100"
				}, {
					"lightness": "-5"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		}
	];


</script>
<style lang="scss">
	.sell-point {

		margin-top: 40px;
		margin-bottom: 40px;

		&__list {

			&__ul {
				padding-left: 0;
				list-style: none;
				height: 860px;
				overflow: hidden;
				overflow-y: auto;
				&__li {
					padding: 20px;
					cursor: default;
					margin-bottom: 10px;
					opacity: 0.5;
					border: 2px solid transparent;
					&.visible {
						opacity: 1;
					}
					&.hover {
						border-color: #d7c8a1;
					}
				}
			}
			&__title {
				color: #fff;
				font-size: 18px;
			}
			&__info {
				opacity: 0.6;
			}
		}
		&__map {
			overflow: hidden;
			border-radius: 4px;
		}

	}
</style>
